export const A4Width = 750;
export const A4Height = 1100;
export const LandscapeA4HeightInPx = `${A4Width}px`;
export const LandscapeA4WidthInPx = `${A4Height}px`;
export const HeaderHeight = "80px";
